// extracted by mini-css-extract-plugin
export var description = "Intro-module--description--ff060";
export var illustration = "Intro-module--illustration--9f2fe";
export var illustrationImage = "Intro-module--illustrationImage--0e9bc";
export var postscript = "Intro-module--postscript--383fe";
export var video = "Intro-module--video--9af98";
export var videoSection = "Intro-module--videoSection--949d0";
export var wrapper = "Intro-module--wrapper--f3589";